module.exports = __webpack_public_path__ + "img/450x325.141bae4f.png";